import { signal } from '@preact/signals';
import { api, authState } from '../state/auth.js';
import { whenModule } from './plan.js';

// AI-schrijfhulp: whether this member gets the ✨ buttons (Professional, a key set by the
// club, and ai:read in the role). Asked once per user and club.
export const aiAvailable = signal({ key: null, available: false });
let pending = null;

export function loadAiStatus() {
  const { userId, activeClubId } = authState.value;
  const key = `${userId}:${activeClubId}`;
  if (aiAvailable.value.key === key || pending?.key === key) return;
  const promise = whenModule(key, 'ai')
    .then(on => (on ? api('/api/ai-help/status') : { available: false }))
    .catch(() => ({ available: false }))
    .then(({ available }) => { if (pending?.key === key) aiAvailable.value = { key, available: !!available }; });
  pending = { key, promise };
}

// After the admin changed the settings
export function resetAiStatus() {
  pending = null;
  aiAvailable.value = { key: null, available: false };
  loadAiStatus();
}

export const AI_ERRORS = {
  ai_key_invalid: 'De AI-sleutel van de club werkt niet. Vraag je beheerder om hem te controleren.',
  ai_key_unreadable: 'De AI-sleutel moet opnieuw worden ingevuld. Vraag je beheerder.',
  ai_quota: 'Het AI-tegoed van de club is op. Vraag je beheerder om bij te vullen.',
  ai_busy: 'De AI-dienst is even druk. Probeer het over een minuut opnieuw.',
  ai_model_unavailable: 'Het gekozen AI-model is niet beschikbaar. Vraag je beheerder een ander model te kiezen.',
  ai_timeout: 'De AI-dienst reageert niet. Probeer het opnieuw.',
  ai_unreachable: 'De AI-dienst is niet bereikbaar. Probeer het opnieuw.',
  ai_limit_user: 'Je hebt het afgelopen uur veel voorstellen gevraagd. Probeer het straks opnieuw.',
  ai_limit_club: 'De club heeft vandaag het maximum aantal AI-voorstellen bereikt. Morgen kan het weer.',
  ai_text_required: 'Schrijf eerst iets om te verbeteren.',
  ai_text_too_long: 'De tekst is te lang voor de schrijfhulp.',
  ai_not_configured: 'De club heeft de AI-schrijfhulp (nog) niet ingesteld.',
  ai_empty: 'De AI gaf geen tekst terug. Probeer het opnieuw.',
  ai_bad_answer: 'De AI gaf geen bruikbaar antwoord. Probeer het opnieuw.',
};
export const aiError = err => AI_ERRORS[err?.code] || 'Het voorstel lukte niet. Probeer het opnieuw.';
